// import helpers from "../helpers/global-helper";
// import queryString from "query-string";
// import {isEmpty} from "lodash/lang";
//
//
//
// export default class BaseApiService {
//     _baseUrl = ''
//     _apiBase = ''
//     _defaultQuery = {}
//
//     constructor() {
//         this._baseUrl = helpers.getBaseUrl()
//         this._defaultQuery = helpers.getDefaultQueryParams();
//         this._apiBase = '';
//     }
//
//     getResource = async (url, obj = {}, method = 'GET') => {
//
//         const query = this.getParams(obj)
//
//         let queryParams = {}
//         let headers = helpers.getHeaders()
//
//         if (query instanceof FormData) {
//             queryParams = query;
//             headers = {}
//
//             if (window.location.hostname === 'localhost') {
//                 const username = 'dev'
//                 const password = 'dev112014'
//
//                 const encodedCredentials = window.btoa(`${username}:${password}`);
//                 headers = { ...headers, 'Authorization': `Basic ${encodedCredentials}` };
//             }
//
//         } else {
//             queryParams = !isEmpty(query)
//                 ? (method === 'GET') ? `/?${query}` : query
//                 : (method === 'GET') ? '' : {}
//         }
//
//         const link = `${this._apiBase}${url}`
//         const fullUrl = (method === 'GET') ? `${link}${queryParams}` : link
//
//         let params = {
//             method,
//             credentials: 'same-origin',
//             headers
//         }
//
//         if (method !== 'GET') {
//             params.body = queryParams
//         }
//
//         const response = await fetch(fullUrl, params);
//
//         const ajaxData = await response.json();
//
//         this._protectedRunXenForoMethod(ajaxData)
//
//         if ('error' in ajaxData || !response.ok) {
//
//             console.error(`Could not fetch ${url}, received ${response.status}`)
//
//             // throw new Error(`Could not fetch ${url}, received ${response.status}`)
//         }
//
//         return ajaxData;
//     }
//
//     getParams = (query = {}) => {
//
//         if (query instanceof FormData) {
//             const {_xfNoRedirect, _xfResponseType, _xfRequestUri} = this._defaultQuery
//
//             query.append('_xfNoRedirect', _xfNoRedirect);
//             query.append('_xfResponseType', _xfResponseType);
//             query.append('_xfRequestUri', _xfRequestUri);
//
//             if ('_xfToken' in this._defaultQuery) {
//                 query.append('_xfToken', this._defaultQuery._xfToken);
//             }
//
//             if ('type' in this._defaultQuery) {
//                 query.append('type', this._defaultQuery.type);
//             }
//
//             return query
//         }
//
//         let data = {...query, ...this._defaultQuery}
//
//         return queryString.stringify(data);
//     }
//
//     _protectedRunXenForoMethod = (ajaxData) => {
//         if (typeof ajaxData == 'object') {
//             if (window.XenForo !== undefined) {
//                 window.XenForo.protectedRunXenForoMethod(ajaxData)
//             }
//         }
//     }
//
// }


import helpers from "../helpers/global-helper";
import queryString from "query-string";
import { isEmpty } from "lodash/lang";

export default class BaseApiService {
    _baseUrl = "";
    _apiBase = "";
    _defaultQuery = {};

    constructor() {
        this._baseUrl = helpers.getBaseUrl();
        this._defaultQuery = helpers.getDefaultQueryParams();
        this._apiBase = "";
    }

    /**
     * ��������� ������ � ������� � ��������� URL � �����������.
     * @param {string} url - ���� � �������.
     * @param {Object|FormData|URLSearchParams} obj - ������ ��� ������� (������, FormData ��� URLSearchParams).
     * @param {string} method - ����� ������� (GET, POST � �.�.).
     * @returns {Promise<Object>} - JSON-����� �� �������.
     */
    getResource = async (url, obj = {}, method = "GET") => {
        const query = this.getParams(obj);
        let queryParams = {};
        let headers = helpers.getHeaders();

        // ���������� ��� ������ � ��������������� ���������
        if (obj instanceof FormData) {
            queryParams = query; // FormData ��� �������� ������
            headers = {}; // ������� ���������, ������� ��������� multipart/form-data �������������

            if (window.location.hostname === "localhost") {
                const username = "dev";
                const password = "dev112014";
                const encodedCredentials = window.btoa(`${username}:${password}`);
                headers = { ...headers, Authorization: `Basic ${encodedCredentials}` };
            }
        } else if (obj instanceof URLSearchParams) {
            queryParams = query; // URLSearchParams ��� application/x-www-form-urlencoded
            headers["Content-Type"] = "application/x-www-form-urlencoded";
        } else {
            // ������ ������ (��������, ��� GET ��� �������������� � URLSearchParams ��� POST)
            queryParams = !isEmpty(query)
                ? method === "GET"
                    ? `/?${query}`
                    : new URLSearchParams(query).toString()
                : method === "GET"
                    ? ""
                    : "";
            headers["Content-Type"] = "application/x-www-form-urlencoded";
        }

        const link = `${this._apiBase}${url}`;
        const fullUrl = method === "GET" ? `${link}${queryParams}` : link;

        let params = {
            method,
            credentials: "same-origin",
            headers,
        };

        if (method !== "GET" && queryParams) {
            params.body = queryParams instanceof FormData ? queryParams : queryParams.toString();
        }

        const response = await fetch(fullUrl, params);

        const ajaxData = await response.json();

        this._protectedRunXenForoMethod(ajaxData);

        if ("error" in ajaxData || !response.ok) {
            console.error(`Could not fetch ${url}, received ${response.status}`);
            console.error('Server error details:', ajaxData.error);
            // throw new Error(`Could not fetch ${url}, received ${response.status}`);
        }

        return ajaxData;
    };

    /**
     * ��������� ��������� ������� � ����������� �� ���� ������.
     * @param {Object|FormData|URLSearchParams} query - ������� ������.
     * @returns {FormData|URLSearchParams|string} - ������� ��������� ��� �������.
     */
    getParams = (query = {}) => {
        if (query instanceof FormData) {
            const { _xfNoRedirect, _xfResponseType, _xfRequestUri, _xfToken, type } = this._defaultQuery;

            query.append("_xfNoRedirect", _xfNoRedirect);
            query.append("_xfResponseType", _xfResponseType);
            query.append("_xfRequestUri", _xfRequestUri);

            if (_xfToken) {
                query.append("_xfToken", _xfToken);
            }

            if (type) {
                query.append("type", type);
            }

            return query;
        } else if (query instanceof URLSearchParams) {
            const { _xfNoRedirect, _xfResponseType, _xfRequestUri, _xfToken, type } = this._defaultQuery;

            query.append("_xfNoRedirect", _xfNoRedirect);
            query.append("_xfResponseType", _xfResponseType);
            query.append("_xfRequestUri", _xfRequestUri);

            if (_xfToken) {
                query.append("_xfToken", _xfToken);
            }

            if (type) {
                query.append("type", type);
            }

            return query;
        } else {
            let data = { ...query, ...this._defaultQuery };
            return queryString.stringify(data); // ��� �������� ������������� � ���������
        }
    };

    /**
     * ��������� ���������� ������ XenForo, ���� ��� ��������.
     * @param {Object} ajaxData - ������ �� �������.
     */
    _protectedRunXenForoMethod = (ajaxData) => {
        if (typeof ajaxData === "object" && window.XenForo !== undefined) {
            window.XenForo.protectedRunXenForoMethod(ajaxData);
        }
    };
}